export const itinerary_listing_events = {
  chat_itinerary_card_click: {
    category: "User navigates itinerary details page",
    action: "User clicks on image card",
    label: "home-itinerary-card-click",
  },
  chat_places_to_visit_card_click: {
    category: "User clicks on suggested trips from the response",
    action: "User clicks on iterinary trip card",
    label: "home-place-suggestion-card-click",
  },
  Show_more_click: {
    category: "User sees more destination list options",
    action: "User clicks on show more button",
    label: "home-view-more-click",
  },
  chat_itinerary_book_click: {
    category: "Chat itinerary",
    action: "User clicks book in chat itinerary",
    label: "home-itinerary-book-click",
  },
  itinerary_details_cancel_click: {
    category: "User clicks on itinerary details cancel",
    action: "User clicks on itinerary details cancel button",
    label: "itinerary-details-cancel-click",
  },
};
